import { Stack, Typography } from '@mui/material';
import React from 'react';
import ButtonWithLoading from 'src/components/common/ButtonWithLoading';
import ModalComponent from 'src/components/Modal/ModalComponent';

// Utilities
import { ICON_DO_NOT_HAVE_ENOUGH_CREDIT } from 'src/utils/constants/imagesUrl';
import { NotifyType, useNotifyCreditCosts } from 'src/zustand/useNotifyCreditCosts';
import { useNavigate } from 'react-router-dom';
import { AuthRouteKeys } from 'src/utils/constants/routes';
import ImageComponent from 'src/components/common/Image';

const NotifyNotEnoughCredit: React.FC = () => {
  const navigate = useNavigate();
  const { open, type, handleCloseNotify, showCloseIcon, cbClose } = useNotifyCreditCosts((state) => state);

  const navigatePricingPage = () => {
    navigate(AuthRouteKeys.Pricing);
    handleCloseNotify();
  };

  return (
    <ModalComponent
      closeOnBackdropClick={false}
      padding={4}
      open={open && type === NotifyType.NotEnoughCredit}
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: 'rgba(45, 45, 45, 0.72)',
            backdropFilter: 'blur(4px)',
            WebkitBackdropFilter: 'blur(4px)',
          },
        },
      }}
      handleClose={() => {
        handleCloseNotify();
        cbClose?.();
      }}
      showCloseIcon={showCloseIcon}
    >
      <Stack direction="column" spacing={2} width={504} alignItems="center">
        <ImageComponent imgSrc={ICON_DO_NOT_HAVE_ENOUGH_CREDIT} height={150} />
        <Typography textAlign="center" variant="h5">
          Does Not Have Enough Credits
        </Typography>
        <Typography textAlign="center" variant="body1">
          Your account currently does not have enough credits to perform this request. To continue exploring and
          unlocking valuable data,{' '}
          <Typography
            onClick={() => navigatePricingPage()}
            component="span"
            color="secondary.main"
            sx={{ cursor: 'pointer' }}
          >
            please visit the All Plans page
          </Typography>{' '}
          and choose a suitable credit package.
        </Typography>
        <ButtonWithLoading
          variant="contained"
          color="primary"
          size="large"
          onClick={() => navigatePricingPage()}
          fullWidth
          isRounded
        >
          visit all plans
        </ButtonWithLoading>
      </Stack>
    </ModalComponent>
  );
};

export default NotifyNotEnoughCredit;
